export default class NavigationModel {
  public name: string
  public route: string
  public params: any

  public constructor(name: string, route: string, param: any) {
    this.name = name
    this.route = route
    this.params = param
  }
}
